module.exports = __webpack_public_path__ + "img/service-08.b6a825bd.png";